import script from "./ArtifactSummarizationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtifactSummarizationPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup});
